import debounce from 'lodash/debounce'

import { useDataCart } from './data-cart'

/**
 * @typedef {object} DataForBehavior
 * @property {string} itemId - id продукта (из api)
 */

/**
 * Возвращает обработчик
 * @param {Ref<DataForBehavior>} data
 * @param {Ref<boolean>} cancelDefaultAddToCart
 * @param {Function} emit
 */
export const useBehavior = (data, cancelDefaultAddToCart, emit) => {
  const { $gaApp } = useNuxtApp()

  const { dataCart } = useDataCart(data)

  const onCartClick = debounce(() => {
    emit('click-add-to-cart', unref(dataCart))

    if (unref(cancelDefaultAddToCart)) return

    $gaApp.services.product.cart.addItem(unref(dataCart))

    emit('add-to-cart', unref(dataCart))
  }, 200)

  return {
    onCartClick,
  }
}
